import { render, staticRenderFns } from "./Tracker.vue?vue&type=template&id=5dd4a1a5&"
import script from "./Tracker.vue?vue&type=script&lang=ts&"
export * from "./Tracker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports